export default __webpack_public_path__ + "static/media/pools-placeholder-dark.2248c52b.png";